import { IS_BLOCKING_SETTINGS, PATH_NAME_SETTINGS } from '../redux/actions/settings-action';

export const isBlockingSettingsReducer = (previousState = false, { type, payload }) => {
    if (type === IS_BLOCKING_SETTINGS) {
        return payload;
    }
    return previousState;
};

export const pathNameSettingsReducer = (previousState = '/settings', { type, payload }) => {
    if (type === PATH_NAME_SETTINGS) {
        return payload;
    }
    return previousState;
};
